import { render, staticRenderFns } from "./edit-bidding.vue?vue&type=template&id=57bef5cf&scoped=true"
import script from "./edit-bidding.vue?vue&type=script&lang=js"
export * from "./edit-bidding.vue?vue&type=script&lang=js"
import style0 from "./edit-bidding.vue?vue&type=style&index=0&id=57bef5cf&prod&lang=less&scoped=true"
import style1 from "./edit-bidding.vue?vue&type=style&index=1&id=57bef5cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bef5cf",
  null
  
)

export default component.exports